module.exports = __webpack_public_path__ + "img/part-3-title.95aa95f5.png";